export enum PaymentGatewaysEnum {
  Stripe = 'stripe',
  PaypalSoap = 'paypal_soap',
  PaypalRest = 'paypal_rest',
  MercadoPago = 'mercadopago',
  Razorpay = 'razorpay',
  Flutterwave = 'flutterwave',
  Mollie = 'mollie',
  Gocardless = 'gocardless',
  Xendit = 'xendit',
  Paystack = 'paystack',
  SecureAndPay = 'secure_and_pay',
  CashOnDelivery = 'cash_on_delivery',
}
